export function SetAuthorisationHeaders(headers: Headers) {
    const token = JSON.parse(window.sessionStorage.getItem('auth') || '{}');
    if (token.access_token) {
      headers.set("authorization", `Bearer ${token.access_token}`);
      headers.set("Content-Type", "application/json");
      headers.set("x-tenant-id", "mvf");
    }
    return headers;
};
